import { useMemo } from 'react';

import { CustomFieldEntity, customFieldsApi } from 'apis/customFields';

type UseHasRequiredAttributesOptions = {
  entityId: CustomFieldEntity;
};

/**
 * A hook for determining whether custom attributes of an entity have required
 * attributes.
 */
export function useHasRequiredAttributes({
  entityId,
}: UseHasRequiredAttributesOptions): boolean {
  const { currentData } = customFieldsApi.useReadAttributesQuery({
    entityId,
  });

  return useMemo(() => {
    return !!currentData?.data.attributes.some(
      ({ is_required, is_archived, is_deactivated }) =>
        is_required && !is_archived && !is_deactivated,
    );
  }, [currentData?.data.attributes]);
}
